// Due dates are calendar dates with no meaningful time-of-day (stored as a
// "YYYY-MM-DD" prefix on a UTC-midnight ISO string). They must never be run
// through `new Date(isoString).toLocaleDateString()` — that reinterprets the
// UTC instant in the viewer's local timezone and can shift the displayed day
// by one. Everything here works off the date-only string or the viewer's own
// local calendar date instead.

function toLocalDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function todayLocal(): string {
  return toLocalDateString(new Date());
}

export function formatDueDate(dueDate: string): string {
  const [y, m, d] = dueDate.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString();
}

export function isOverdue(dueDate: string, asOf: Date = new Date()): boolean {
  return dueDate.slice(0, 10) < toLocalDateString(asOf);
}
